export function filtersToggle() {
    $('.sidebar-btn.view-more').on("click", function () {
        const $this = $(this);
        const span = $this.find('span');
        const hiddenItems = $this.parent().find(".hidden");
        if(!$this.hasClass("active")) {
            span.text("View less");
            $this.addClass("active");
            hiddenItems.slideDown();
        } else {
            span.text("View More");
            $this.removeClass("active");
            hiddenItems.slideUp();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/filtersToggle.js